import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Suppress React error overlay for avatar loading errors
if (process.env.NODE_ENV === 'development') {
  // Override window.onerror to catch errors before React's overlay
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    const errorMessage = message || (error && error.message) || String(error || '') || '';
    if (errorMessage.includes('readyplayer.me') || 
        errorMessage.includes('Failed to fetch') ||
        errorMessage.includes('ERR_CERT_AUTHORITY_INVALID') ||
        errorMessage.includes('Could not load')) {
      console.warn("[Avatar] Suppressed error overlay:", message);
      return true; // Prevent default error handling and React overlay
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const errorMessage = reason?.message || String(reason || '') || '';
    if (errorMessage.includes('readyplayer.me') || 
        errorMessage.includes('Failed to fetch') ||
        errorMessage.includes('ERR_CERT_AUTHORITY_INVALID') ||
        errorMessage.includes('Could not load')) {
      console.warn("[Avatar] Suppressed unhandled rejection:", reason);
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true); // Use capture phase

  // Also intercept errors at the event level
  window.addEventListener('error', (event) => {
    const error = event.error;
    const errorMessage = error?.message || String(error || '') || event.message || '';
    if (errorMessage.includes('readyplayer.me') || 
        errorMessage.includes('Failed to fetch') ||
        errorMessage.includes('ERR_CERT_AUTHORITY_INVALID') ||
        errorMessage.includes('Could not load')) {
      console.warn("[Avatar] Suppressed error event:", errorMessage);
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true); // Use capture phase to catch early
}

ReactDOM.render(<App />, document.getElementById("root"));
